/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {margin_b_lg, padding_rl_sm, Spacing} from "@styles/styles";
import {ConfigGeneralWrapper} from "./ConfigGeneralWrapper";
import {DB_Patient} from "@app/app-shared/patient";
import {checkinFieldDefsArrayForOrganization, measurementFieldDefsArrayForOrganization} from "@app/app-shared/care_config";
import {AppointmentInfoWrapper} from "./AppointmentInfoWrapper";
import {MedicationReminderInfoWrapper} from "../ui/reminders/MedicationReminderInfoWrapper";
import {OrganizationsContext} from "../ui/organizations/OrganizationsContext";

export class CarePlanConfig
    extends React.Component<{ selectedPatient: DB_Patient }> {

    renderLeftColumn = (patient: DB_Patient) => {
        return <OrganizationsContext.Consumer>
            {orgCtx => <div className={`ll_v_s`}>
                <ConfigGeneralWrapper
                    patient={patient}
                    fieldDefs={checkinFieldDefsArrayForOrganization(orgCtx.organizations[patient.organizationId])}
                    title={"General check-in"}
                    showActions={false}
                />
                <ConfigGeneralWrapper
                    patient={patient}
                    fieldDefs={measurementFieldDefsArrayForOrganization()}
                    title={"Recommended measurements"}
                    showActions={true}
                />
            </div>}
        </OrganizationsContext.Consumer>;
    };

    renderRightColumn = (patient: DB_Patient) => {
        return (
            <div>
                <AppointmentInfoWrapper patient={patient}/>
                <MedicationReminderInfoWrapper patient={patient}/>
            </div>
        );
    };

    render() {
        const patient = this.props.selectedPatient
        return <div className={`ll_h_s ${margin_b_lg}`} style={{marginLeft: -Spacing.s, marginRight: -Spacing.s}}>
            {/* Left Column */}
            <div className={`ll_v_s ${padding_rl_sm}`} style={{flex: 1}}>
                {this.renderLeftColumn(patient)}
            </div>

            {/* Right Column */}
            <div className={`ll_v_s ${padding_rl_sm}`} style={{flex: 1}}>
                {this.renderRightColumn(patient)}
            </div>
        </div>
    }
}
